import { css } from 'styled-components';

export const StyledLink = ({ theme }: any) => css`
    font-weight: ${theme.fontWeights.semiBold};
`;

export const StageHeading = ({ theme }: any) => css`
    color: ${theme.colors.global.white};
    background-color: #27314a;
`;

export const LoadingSpinnerBranded = ({ theme }: any) => css`
    color: ${theme.colors.global.white};
`;

export const CardContainer = css`
    background: linear-gradient(155deg, #ff8791 7.72%, #ffe433 102.75%);
`;

export const OBPendingSpinnerHeading = ({ theme }: any) => css`
    color: ${theme.colors.global.white};
`;

export const TitleSection = ({ theme }: any) => css`
    background-color: ${theme.colors.capitalOne.blue750};
`;

export const TitleSectionNoPadding = () => css`
    padding: 0;
`;

export const LogoStyled = () => css`
    width: 14rem;
    height: 4.8rem;
`;

export const TitleSectionHeading = ({ theme }: any) => css`
    color: ${theme.colors.global.white};
`;
